import label from '../../assets/i18n/en.json'
const PatientMenu =
    [
        { title: 'Dashboard', path: '', icon: 'home' },
        { title: 'Appointments', path: 'appointments', icon: 'calendar alternate outline' },
        { title: 'Financial Profile', path: 'financial', icon: 'dollar' },
        { title: 'Settings', path: 'settings', icon: 'cogs' },
    ]

export default PatientMenu